import { useSelector } from "react-redux";
import { createObjectId } from "./chat/helper";
import { chatOfUser, ClientSeenMessage, meassage, receiveMessages, RegisterOperatorResponse, SeenMessageObj, TotalCountUnReadChat, UserStatus } from "./chat/inerface/iterface";

class DataStore {

  private static instance: DataStore;
  private data: Map<string | undefined, chatOfUser> = new Map();
  private filterData: Map<string | undefined, chatOfUser> = new Map();

  private selectedConversation: Map<string | undefined, chatOfUser> = new Map();
  private selectedTab: number | null = null
  private loading: boolean = false
  private isRefresh: boolean = false
  private totalCountUnReadChat: TotalCountUnReadChat =
    {
      totalCountUnReadOpenChat: null,
      totalCountUnReadWaitingChat: null
    }


  private userId: string | null

  constructor() {

    this.userId = localStorage.getItem("user_chat")
    if (!DataStore.instance) {
      this.data = new Map();
      this.filterData = new Map();
      this.selectedConversation = new Map();
      this.selectedTab = null
      this.loading = false
      this.isRefresh = false
      this.totalCountUnReadChat.totalCountUnReadOpenChat = null
      this.totalCountUnReadChat.totalCountUnReadWaitingChat = null

      DataStore.instance = this;
    }
    return DataStore.instance;
  }

  setLoading(loading: boolean) {
    this.loading = loading
  }
  getLoading() {
    return this.loading
  }



  getData() {
    return this.data;
  }

  getSelectedConversation() {
    return this?.selectedConversation
  }

  getSelectedTab() {
    return this.selectedTab
  }

  addSelectedConversation(id: string, value: chatOfUser) {

    this.selectedConversationClear()
    this.selectedConversation.set(
      id, {
      messages: value?.messages,
      ownerId: value.ownerId,
      user: value.user,
      participants: value?.participants,
      count: value?.count,
      lastStatus: value?.lastStatus,
      clientSeenMessages: value?.clientSeenMessages,
      domain: value?.domain,
      startDateTime: value?.startDateTime,
      lastParticipant: value?.lastParticipant,
      totalClientUnreadMessage: value?.totalClientUnreadMessage,
      lastParticipantUserId: value?.lastParticipantUserId

    })
  }

  updateSelectedConversation(id: string, value: chatOfUser) {
    const existing = this.selectedConversation.get(id);
    value && this.selectedConversation.set(id, {
      ...existing,
      participants: value?.participants,
      messages: value?.messages,
      lastParticipantUserId: value?.lastParticipantUserId


    })
  }

  setSelectedTab(tab: number | null) {
    this.selectedTab = tab
  }

  setSelectedConversation(id: string | null, from: string | null) {


    if (id && from) {
      const value = this.data?.get(id);
      if (from === "click" || !this.selectedConversation?.has(id)) {
        value && this.addSelectedConversation(id, value)
      }
      else if (from === "add" && this.selectedConversation?.has(id)) {
        value && this.updateSelectedConversation(id, value)
      }
    }
    else {
      this.selectedConversationClear()

    }

  }

  getTab() {
    let tmp = localStorage.getItem("tab")
    if (tmp !== null) return parseInt(tmp)
    else return 2
  }

  // setTotalCountUnReadChatFromData(_value: chatOfUser) {
  //   debugger
  //   let count = 0
  //   if (_value?.lastStatus === 2) {
  //     let userId = localStorage.getItem("user_chat")
  //     let findIndex = null

  //     if (_value?.clientSeenMessages && _value?.clientSeenMessages?.length > 0) findIndex = _value?.clientSeenMessages?.findIndex((_item: any) => createObjectId(_item?.userId) === userId)
  //     else if (_value?.clientSeenMessages?.length === 0 || _value?.clientSeenMessages === null) findIndex = null

  //     if (findIndex === undefined || findIndex === null) count = _value?.totalClientUnreadMessage!
  //     else if (findIndex > -1) count = 0

  //     else if (findIndex === -1 && _value?.messages) count = _value?.messages?.size
  //     else if (findIndex === -1 && !_value?.messages) count = 0

  //   }
  //   else if (_value?.lastStatus === 0) {
  //     count = _value?.totalClientUnreadMessage!
  //   }
  //   debugger
  //   this.setTotalCountUnReadChat(_value?.lastStatus!, count)

  // }

  setTotalCountUnReadChatFromData(_value: chatOfUser) {
    let count = 0
    if (_value?.lastStatus !== 2) {
      count = _value?.totalClientUnreadMessage!;
    }

    const userId = localStorage.getItem("user_chat");
    const seenMessages = _value?.clientSeenMessages ?? [];
    const hasSeen = seenMessages.some((msg: any) => createObjectId(msg?.userId) === userId);

    //اگر حداقل یه یوزر پیدا شد
    if (hasSeen) count = 0;

    //اگر ارایه خالی باشه
    else if (!seenMessages.length) count = _value?.totalClientUnreadMessage!

    //  آرایه پر هست و یوزر پیدا نشد
    else count = _value?.messages?.size ?? 0

    // if (_value?.lastStatus === 2) {
    //   let userId = localStorage.getItem("user_chat")
    //   let findIndex = null

    //   if (_value?.clientSeenMessages && _value?.clientSeenMessages?.length > 0) findIndex = _value?.clientSeenMessages?.findIndex((_item: any) => createObjectId(_item?.userId) === userId)
    //   else if (_value?.clientSeenMessages?.length === 0 || _value?.clientSeenMessages === null) findIndex = null

    //   if (findIndex === undefined || findIndex === null) count = _value?.totalClientUnreadMessage!
    //   else if (findIndex > -1) count = 0

    //   else if (findIndex === -1 && _value?.messages) count = _value?.messages?.size
    //   else if (findIndex === -1 && !_value?.messages) count = 0

    // }
    // else if (_value?.lastStatus === 0) {
    //   count = _value?.totalClientUnreadMessage!
    // }
    this.setTotalCountUnReadChat(_value?.lastStatus!, count)

  }


  addToTopList(callBackValue: receiveMessages, mapMessage: Map<string | undefined, meassage>) {
    const newEntry: [string | undefined, chatOfUser] = [
      callBackValue?.id,
      {
        messages: mapMessage,
        ownerId: callBackValue?.ownerId,
        user: callBackValue?.user,
        participants: callBackValue?.participants,
        totalClientUnreadMessage: callBackValue?.totalClientUnreadMessage,
        lastStatus: callBackValue?.lastStatus,
        clientSeenMessages: callBackValue?.clientSeenMessages,
        domain: callBackValue?.domain,
        startDateTime: callBackValue?.startDateTime,
        lastParticipant: callBackValue?.lastParticipant,
        lastParticipantUserId: callBackValue?.lastParticipantUserId

      }
    ];

    const newMap = new Map<string | undefined, chatOfUser>([
      newEntry,
      ...[...this.data.entries()].filter(([key]) => key !== callBackValue?.id) // جلوگیری از تکرار کلید
    ]);
    this.data = newMap;
  }

  groupByChat = (callBackValue: receiveMessages | null, isCurrent: boolean, isScroll: boolean) => {
    let tmp = callBackValue
    let mapMessage = new Map<string | undefined, meassage>()
    if (callBackValue) {
      if (!this.data?.has(callBackValue?.id)) {
        tmp?.messages?.forEach((item, index) => {
          let idMessage = createObjectId(item?.id)
          mapMessage.set(idMessage, item)
        })
        if (isCurrent && this.data && this.data?.size > 0) {
          this.addToTopList(callBackValue, mapMessage)

        }
        else {
          this.data && this.data.set(callBackValue?.id, {
            messages: mapMessage,
            ownerId: tmp?.ownerId,
            user: tmp?.user,
            participants: tmp?.participants,
            totalClientUnreadMessage: tmp?.totalClientUnreadMessage,
            lastStatus: tmp?.lastStatus,
            clientSeenMessages: tmp?.clientSeenMessages,
            domain: tmp?.domain,
            startDateTime: tmp?.startDateTime,
            lastParticipant: tmp?.lastParticipant,
            lastParticipantUserId: callBackValue?.lastParticipantUserId




          })
        }
      }
      else {
        let ixd = callBackValue?.id!

        if (isScroll) {
          const newMap = new Map()
          const existingEntry = this.data.get(ixd);
          tmp?.messages &&
            tmp?.messages?.forEach((item, index) => {
              let idMessage = createObjectId(item?.id)
              newMap.set(idMessage, item)
            }
            );
          existingEntry?.messages?.forEach((_value, _key) => {
            newMap.set(_key, _value)
          })
          this.data.set(ixd, {
            ...existingEntry,
            messages: newMap,
            lastStatus: callBackValue?.lastStatus,
            clientSeenMessages: callBackValue?.clientSeenMessages,
            domain: tmp?.domain,
            startDateTime: tmp?.startDateTime,
            ownerId: tmp?.ownerId,
            user: tmp?.user,
            participants: tmp?.participants,
            totalClientUnreadMessage: tmp?.totalClientUnreadMessage,
            lastParticipant: tmp?.lastParticipant,
            lastParticipantUserId: tmp?.lastParticipantUserId



          })
        }
        else if (isCurrent || this.isRefresh) {
          if (this.isRefresh) this.isRefresh = false

          // if (callBackValue?.messages !== undefined && callBackValue?.messages[0]?.messageFrom === 1) {
          //
          //   tmp?.messages?.forEach((item, index) => {
          //     let idMessage = createObjectId(item?.id)
          //     mapMessage.set(idMessage, item)
          //   })
          //   this.addToTopList(callBackValue, mapMessage)
          // }
          // else {
          const newMap = new Map()
          const existingEntry = this.data.get(ixd);
          existingEntry?.messages?.forEach((_item, index) => {
            let idMessage = createObjectId(_item?.id)
            newMap.set(idMessage, _item)
          })
          tmp?.messages &&
            tmp?.messages?.forEach((item, index) => {
              let messageId = createObjectId(item?.id)
              newMap.set(messageId, item)
            }
            );
          this.addToTopList(callBackValue, newMap)
          // this.data.set(ixd, {
          //   ...existingEntry, // Keep other properties
          //   messages: newMap, // Update messages to the newMap
          //   totalClientUnreadMessage: tmp?.totalClientUnreadMessage,
          //   lastStatus: callBackValue?.lastStatus,
          //   clientSeenMessages: tmp?.clientSeenMessages,
          //   domain: tmp?.domain,
          //   startDateTime: tmp?.startDateTime,
          //   ownerId: tmp?.ownerId,
          //   user: tmp?.user,
          //   participants: tmp?.participants,
          //   lastParticipant: tmp?.lastParticipant

          // })
          // }

        }
      }
    }
    this.setTotal()
  }

  setTotal() {
    let _tmp = this?.totalCountUnReadChat
    _tmp.totalCountUnReadOpenChat = 0
    _tmp.totalCountUnReadWaitingChat = 0
    this?.data?.forEach((_value, _key) => {
      if (_value?.lastStatus !== undefined && _value?.clientSeenMessages !== undefined && _value?.totalClientUnreadMessage !== undefined) this?.setTotalCountUnReadChatFromData(_value)
    })
  }


  setFilter() {
    const newMap = new Map();
    this.filterData = newMap
    this?.data?.forEach((_value, _key) => {
      if (_value?.lastStatus === this.selectedTab) {
        this.filterData.set(_key, _value)
      }
    })
  }

  getFilterData() {
    return this.filterData
  }
  addItem(item: receiveMessages, isCurrent: boolean, isScroll: boolean,) {
    this.groupByChat(item, isCurrent, isScroll)
  }

  readMessage(callBackValue: receiveMessages) {
    let _idx = callBackValue?.id
    let existEntry = this.data.get(_idx)

    const newMap = new Map()
    callBackValue?.messages &&
      callBackValue?.messages?.forEach((item, index) => {
        let idMessage = createObjectId(item?.id)
        newMap.set(idMessage, item)
      }
      );
    this.data.set(_idx, {
      ...existEntry,
      messages: newMap,
      totalClientUnreadMessage: callBackValue?.totalClientUnreadMessage,
      clientSeenMessages: callBackValue?.clientSeenMessages,
      domain: callBackValue?.domain,
      startDateTime: callBackValue?.startDateTime,
      ownerId: callBackValue?.ownerId,
      user: callBackValue?.user,
      participants: callBackValue?.participants,
      lastStatus: callBackValue?.lastStatus,
      lastParticipant: callBackValue?.lastParticipant,
      lastParticipantUserId: callBackValue?.lastParticipantUserId



    })
    this.setFilter()
    callBackValue?.lastStatus !== 2 && callBackValue?.lastStatus !== undefined && callBackValue?.messages !== undefined && callBackValue?.totalClientUnreadMessage !== undefined && this.setTotal()



  }

  selectedConversationClear() {
    return this.selectedConversation.clear()
  }
  seenMessage(tmp: receiveMessages) {
    let id = tmp?.id
    const existingEntry = this.data.get(id);
    this.data.set(id, {
      ...existingEntry,
      totalClientUnreadMessage: tmp?.totalClientUnreadMessage,
      clientSeenMessages: tmp?.clientSeenMessages,
      lastParticipantUserId: tmp?.lastParticipantUserId

    })

    // this.data.set(id, {
    //   ...existingEntry!,
    //   totalClientUnreadMessage: 0
    // })
    this.setTotal()

  }
  clear() {
    this.data.clear()
  }

  removeChat(id: string) {
    this.data?.delete(id)
  }

  refresh(id: string, type: string) {
    // this.selectedConversationClear()
    const existingEntry = this.data.get(id);
    let status = null
    if (type === "WAITING") status = 0
    if (type === "CLOSING") status = 1
    this.data.set(id, {
      ...existingEntry!,
      lastStatus: status!
    })
    this.isRefresh = true
    return this.data
  }

  emptyTotalCountUnReadChat(status: number) {
    let _tmp = this?.getTotalCountUnReadChat()
    if (status === 0) _tmp.totalCountUnReadOpenChat = 0
    if (status === 2) _tmp.totalCountUnReadWaitingChat = 0
  }

  setTotalCountUnReadChat(status: number, count: number) {
    let _tmp = this?.getTotalCountUnReadChat()
    if (status === 0) {
      this.totalCountUnReadChat.totalCountUnReadOpenChat = _tmp?.totalCountUnReadOpenChat !== null ? _tmp?.totalCountUnReadOpenChat + count : count
    }
    if (status === 2) {
      this.totalCountUnReadChat.totalCountUnReadWaitingChat = _tmp?.totalCountUnReadWaitingChat !== null ? _tmp?.totalCountUnReadWaitingChat + count : count

    }
  }

  getTotalCountUnReadChat() {
    return this.totalCountUnReadChat
  }

  detectOnlineUser(tmp: UserStatus[]) {
    const onlineMap = new Map<string, boolean>();
    tmp?.forEach(user => {
      if (user?.SessionId) {
        onlineMap.set(user.SessionId, user.IsOnline);
      }
    });

    this.data.forEach((value, key) => {
      const sessionId = value?.user?.sessionId
      const isOnline = sessionId ? onlineMap.get(sessionId) ?? false : false
      this.data.set(key, {
        ...value,
        isOnline
      });
    });
  }

  _syncToStorage() {
    localStorage.setItem('appData', JSON.stringify(this.data));
  }

}


const instance = new DataStore();

export default instance;


